import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import * as yup from 'yup';

const useForgottenPasswordFormValidationSchema = () => {
	const { t } = useTranslation();

	return useMemo(
		() =>
			yup.object({
				email: yup.string().email(t('Invalid email address')).required(t('Required')),
			}),
		[t],
	);
};

export default useForgottenPasswordFormValidationSchema;
